module.exports = __webpack_public_path__ + "colors.less";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=colors.less!./src/colors.less
// module id = 110
// module chunks = 0